import { render, staticRenderFns } from "./AttendanceYear.vue?vue&type=template&id=befc91e2"
import script from "./AttendanceYear.vue?vue&type=script&lang=js"
export * from "./AttendanceYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports